export const JSON_ONE1 = {
   
  
        "id": "mayur4367",
    "account_holder_name": "Thrinath",
    "account_number": "2344424",
    "account_type": "C",
    "average_ticket_size": "1",
    "ag_id": "paygate",
    "bank_city": "Hyderabad",
    "bank_id": 1,
    "bussiness_description": "This is for testing only",
    "category_id": "20",
    "city": "Mumbai",
    "company_phone": "8859513309",
    "country_code": "string",
    "createdBy": "MER_ONLINE_BOARD",
    "creationDate": 1630138870000,
    "director_email": "mandy@gmail.com",
    "director_name": "Faming",
    "director_phone": "8859513809",
    "document_urls": "NA",
    "email_id": "mm@tst.com",
    "first_name": "mayur",
    "ifsc_code": "HDFC0000218",
    "is_paid": "N",
    "ag_ref": null,
    "last_name": "madav",
    "merchant_name": "Testme",
    "meId": "202108280002",
    "mobile_no": "8953789076",
    "modificationDate": 1630138888458,
    "modifiedBy": "MER_ONLINE_BOARD",
    "office_address": "Test",
    "pan_number": "PPESR2231Q",
    "password": "$2a$10$lHRiQBvxVGQuTDyKNqXRS.5bg3tu4lHsSxcWaFxlVGJcyaybUWdqO",
    "pincode": "string",
    "pricing_plan": "E",
    "settlement_currency": "INR",
    "state": "Maharastra",
    "status": "P",
    "sub_category": "Entertainment",
    "turnover": " 1000000",
    "website_url": "www.ohk.com",
    "message": "Success",
    "reId": "",
    "statusCode": "00",
    "legal_name": null,
    "legal_office_address": null,
    "company_name": null,
    "indianCustomer": null,
    "iAgree": null,
    "businessType": null
        }

